import { api } from './api'
import { ticketingSystemTicketType } from './tickets'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'ticketFilter',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchTicketFilters: builder.query({
      query: (params) => {
        return ({
          url: `/ticketing_systems/${params.ticketingSystemDisplayId}/user_filters`,
          params: {
            ...(params.providerTicketBoardId && { providerTicketBoardId: params.providerTicketBoardId }),
          },
        })
      },
      providesTags: (result) => [{ type: 'ticketFilter', id: 'LIST' }],
    }),

    createTicketFilter: builder.mutation({
      query: ({ ticketingSystemDisplayId, params }) => ({
        url: `/ticketing_systems/${ticketingSystemDisplayId}/user_filters`,
        method: 'POST',
        body: {
          params: params,
        },
      }),
      invalidatesTags: ['ticketFilter'],
    }),

    updateTicketFilter: builder.mutation({
      query: ({ ticketingSystemDisplayId, ticketFilterId, params }) => ({
        url: `/ticketing_systems/${ticketingSystemDisplayId}/user_filters/${ticketFilterId}`,
        method: 'PATCH',
        body: {
          params: params,
        },
      }),
      invalidatesTags: (result, error, args) => [
        'ticketFilter',
        {
          type: ticketingSystemTicketType,
          id: `TICKET_FILTER_ID_${args.ticketFilterId}`,
        },
      ],
    }),

    removeTicketFilter: builder.mutation({
      query: ({ ticketingSystemDisplayId, ticketFilterId }) => ({
        url: `/ticketing_systems/${ticketingSystemDisplayId}/user_filters/${ticketFilterId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ticketFilter'],
    }),

    fetchTicketFilterFields: builder.query({
      query: ({ ticketingSystemDisplayId }) => {
        return ({
          url: `/ticketing_systems/${ticketingSystemDisplayId}/user_filters/filter_fields`,
        })
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchTicketFiltersQuery,
  useCreateTicketFilterMutation,
  useUpdateTicketFilterMutation,
  useRemoveTicketFilterMutation,
  useFetchTicketFilterFieldsQuery,
} = extendedApi

export const {
  fetchTicketFilterFields,
} = extendedApi.endpoints
